import { Link } from 'react-router-dom'
import { CheckCircle } from 'lucide-react'

export default function BillingSuccessPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full bg-white shadow rounded-lg p-8 text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-green-100 flex items-center justify-center mb-4">
          <CheckCircle className="h-6 w-6 text-green-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">You are on a 30-day free trial</h1>
        <p className="mt-3 text-sm text-gray-600">
          Your card is on file. Billing does not start until the trial ends. You can manage this later from your account.
        </p>
        <Link
          to="/dashboard"
          className="mt-6 inline-block w-full py-2 px-4 rounded-md text-sm font-medium text-white bg-primary-600 hover:bg-primary-700"
        >
          Go to dashboard
        </Link>
      </div>
    </div>
  )
}
